import React from "react";
import { Navigate } from "react-router-dom";
import PrivateRoute from "./Private";
import {
  FULLLAYOUT,
  DASHBOARD,
  BLAKEOUT,
  LOGIN,
  USER_MANAGEMENT,
  CLEANER_MANAGEMENT,
  PROPERTY_MANAGEMENT,
  SUBSCRIPTION_MANAGEMENT,
  SETTING_MANAGEMENT,
  PROFILE,
  NOTIFICATION,
  HOSTHELPERHELPER,
} from "./RouteConstant";
import Login from "../Pages/AUTH/Login/Login";

const Router = [
  {
    path: "/",
    element: <PrivateRoute Component={FULLLAYOUT} />,

    children: [
      { path: "/", element: <Navigate to="/dashboard" /> },
      { path: "/dashboard", exact: true, element: <DASHBOARD /> },
      { path: "user-management", exact: true, element: <USER_MANAGEMENT /> },
      {
        path: "cleaner-management",
        exact: true,
        element: <CLEANER_MANAGEMENT />,
      },
      {
        path: "property-management",
        exact: true,
        element: <PROPERTY_MANAGEMENT />,
      },
      {
        path: "subscription-management",
        exact: true,
        element: <SUBSCRIPTION_MANAGEMENT />,
      },
      { path: "/setting", exact: true, element: <SETTING_MANAGEMENT /> },
      { path: "/notification", exact: true, element: <NOTIFICATION /> },
      { path: "/profile", exact: true, element: <PROFILE /> },

      { path: "*", element: <Navigate to="dashboard" /> },
    ],
  },
  {
    path: "auth",
    element: <BLAKEOUT />,
    children: [{ path: "login", element: <LOGIN /> }],
  },
  {
    path: "/cleaners/webviewhosthelper/:parameter",
    element: <HOSTHELPERHELPER />,
  },
];
export default Router;
